import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import {
  getCustomApiSemiMonthlyAttendanceSyncJobs,
  setCustomApiSemiMonthlyAttendanceSyncJobInvisible,
  fetchCustomApiSemiMonthlyAttendanceSyncJobStatus
} from 'src/reducers/employees/employeeAttendances';
import { Close } from 'jbc-front/components/icons';
import { JobFailed, JobInprogress, JobSuccess } from 'src/components/JobStatus';
import styles from './CustomApiSemiMonthlyAttendanceSyncJobsStatus.scss';

const TaskResult = ({ jobs, status, hideSyncJobNotifications }) => {
  const { t } = useTranslation();
  let statusText = t('features.EmployeeAttendances.components.CustomApiSemiMonthlyAttendanceSyncJobsStatus.Acquired_attendance_data');
  let tasksStyle = styles.tasksSuccess;

  if (status === 'failed') {
    statusText = t('features.EmployeeAttendances.components.CustomApiSemiMonthlyAttendanceSyncJobsStatus.Cannot_acquire_attendance_data');
    tasksStyle = styles.tasksFailed;
  } else if (status === 'inProgress') {
    statusText = t('features.EmployeeAttendances.components.CustomApiSemiMonthlyAttendanceSyncJobsStatus.Acquiring_attendance_data');
    tasksStyle = styles.tasksInprogress;
  }

  return (
    <React.Fragment>
      {!isEmpty(jobs) &&
        jobs.length > 0 && (
          <div className={tasksStyle}>
            <div className={styles.inner}>
              {status === 'success' && (
                <React.Fragment>
                  <div className={styles.close} role="presentation" onClick={() => hideSyncJobNotifications(jobs)}>
                    <Close size={20} />
                  </div>
                  <ul className={styles.list}>
                    {jobs.map(job => (
                      <JobSuccess
                        key={job.id}
                        statusText={statusText}
                        jobInfo={''}
                        startAt={job.executeAt}
                        endAt={job.executeDoneAt}
                        canNotSyncEmployees={job.unsyncedStaff}
                        canNotSyncAllowances={job.unsyncedClientAllowanceItems}
                      />
                    ))}
                  </ul>
                </React.Fragment>
              )}
              {status === 'failed' && (
                <React.Fragment>
                  <div className={styles.close} role="presentation" onClick={() => hideSyncJobNotifications(jobs)}>
                    <Close size={20} />
                  </div>
                  <ul className={styles.list}>
                    {jobs.map(job => (
                      <JobFailed
                        key={job.id}
                        statusText={statusText}
                        jobInfo={''}
                        errorShowMsg={job.externalErrorMsg}
                        startAt={job.executeAt}
                        endAt={job.executeDoneAt}
                      />
                    ))}
                  </ul>
                </React.Fragment>
              )}
              {status === 'inProgress' && (
                <React.Fragment>
                  <ul className={styles.list}>
                    {jobs.map(job => <JobInprogress key={job.id} statusText={statusText} jobInfo={job.taskInfo} startAt={job.executeAt} />)}
                  </ul>
                </React.Fragment>
              )}
            </div>
          </div>
        )}
      {isEmpty(jobs) && null}
    </React.Fragment>
  );
};

class CustomApiSemiMonthlyAttendanceSyncJobsStatus extends React.Component {
  componentDidMount() {
    this.pollFetchVisibleCustomApiSemiMonthlyAttendanceSyncJobs();
  }

  pollFetchVisibleCustomApiSemiMonthlyAttendanceSyncJobs = () => {
    this.props.fetchVisibleCustomApiSemiMonthlyAttendanceSyncJobs();
    setTimeout(this.pollFetchVisibleCustomApiSemiMonthlyAttendanceSyncJobs, 60000);
  };

  render() {
    const { customApiSemiMonthlyAttendanceSyncJobs = {}, hideSyncJobNotifications } = this.props;
    return (
      <React.Fragment>
        {isEmpty(customApiSemiMonthlyAttendanceSyncJobs) ? null : (
          <div>
            {Object.keys(customApiSemiMonthlyAttendanceSyncJobs).map(status => (
              <TaskResult
                key={status}
                jobs={customApiSemiMonthlyAttendanceSyncJobs[status]}
                status={status}
                hideSyncJobNotifications={hideSyncJobNotifications}
              />
            ))}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  customApiSemiMonthlyAttendanceSyncJobs: getCustomApiSemiMonthlyAttendanceSyncJobs(state)
});

const mapDispatchToProps = dispatch => ({
  hideSyncJobNotifications: jobs => {
    const jobIds = jobs.map(j => j.id).join('_');
    if (jobIds.length > 0) {
      dispatch(setCustomApiSemiMonthlyAttendanceSyncJobInvisible(jobIds));
    }
  },
  fetchVisibleCustomApiSemiMonthlyAttendanceSyncJobs: () => dispatch(fetchCustomApiSemiMonthlyAttendanceSyncJobStatus(true))
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomApiSemiMonthlyAttendanceSyncJobsStatus);
